import * as React from 'react';
import * as _ from 'underscore';

import { SiteRoleFilterHelper } from '../../../ts/helpers/SiteRoleFilterHelper';
import { ServerUsers } from '../../../userManagement/services/resources/ServerUsers';
import { IStringValuedFilterClause } from '../../../ts/ServerApi/types/IFilterClause';
import { ISelectFilterDefinition } from '../../../ts/services/FilterPanelService';
import { SiteRolesResource } from '../../../userManagement/services/resources/SiteRoles';
import { ServiceLocator } from '../../ServiceLocator';
import { AdvancedFilterPanel, AdvancedFilterPanelProps, AdvancedFilterPanelScope } from './AdvancedFilterPanel';
import { ServerUserDefinition } from '../../../ts/models/contentDefinitions/ServerUserDefinition';

export interface ServerUsersAdvancedFilterPanelProps extends AdvancedFilterPanelProps {}

export class ServerUsersAdvancedFilterPanel extends React.Component<ServerUsersAdvancedFilterPanelProps> {

  private maxSiteRoleFilterDefinition: ISelectFilterDefinition<string>;
  private siteRoles: SiteRolesResource = undefined;

  public constructor(props: ServerUsersAdvancedFilterPanelProps) {
    super(props);
    this.siteRoles = SiteRolesResource.instance;
  }

  public render() {
    return <AdvancedFilterPanel {...{...this.props, scopeReference: this.scopeRef}} />;
  }

  public componentDidMount() {
    this.updateSiteRoleCounts();
  }

  public componentDidUpdate(prevProps: ServerUsersAdvancedFilterPanelProps) {
    if (this.searchTerm(this.props) !== this.searchTerm(prevProps)) {
      this.updateSiteRoleCounts();
    }
  }

  private updateSiteRoleCounts = async () => {
    let query = ServerUserDefinition.getBasicQuery();
    if (this.searchTerm(this.props)) {
      query = query.addFilter(this.props.mixedContentFilterMap.search);
    }
    const userCountsByRole = await ServerUsers.instance.getUserCountsByMaxSiteRole(query);
    this.maxSiteRoleFilterDefinition.options =
        SiteRoleFilterHelper.siteRoleOptions(this.siteRoles.optionsForCurrentUser(), userCountsByRole);
  }

  private scopeRef = (scope: AdvancedFilterPanelScope) => {
    this.maxSiteRoleFilterDefinition = scope.filterDefinitions[0] as ISelectFilterDefinition<string>;
  }

  private searchTerm = (props: ServerUsersAdvancedFilterPanelProps) => {
    return (props.mixedContentFilterMap.search
      && (props.mixedContentFilterMap.search as IStringValuedFilterClause).value)
      || '';
  }
}
